<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { isUsePhone } from "@/util/axios.js"
import { initializationTDK } from "@/util/thirdPartyAdapter/baiduPromotion.js"
import router from "@/router";
export default {
  name: 'App',

  watch: {
    $route(to, from) {
      window.$route = this.$route
    },
  },
  mounted() {
    const whiteList = ["/UAVFlyManage/navigation_page"]
    const pathname = document.location.pathname
    if(whiteList.indexOf(pathname) >= 0){
      return
    }

    const hrefUrl = window.location.href
    const flag = hrefUrl.indexOf("/mobile") > 0 // 访问的是否是手机端页面
    const name = this.$route.name
    if (!name) {
      if (isUsePhone()) {
        if (!flag) {
          this.$router.push({ name: 'mobile_index' })
        }
      } else {
        if (flag) {
          this.$router.push({ name: 'index' })
        }
      }
    }


  },
  created() {
    initializationTDK()
  },
}
</script>

<style>
::-webkit-scrollbar {
	width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track{
	background: #a4a4a4;
	border-radius: 3px;
}
::-webkit-scrollbar-thumb {
	background: #42586e;
	border-radius: 3px;
}

.el-message-box__wrapper .el-message-box__container img{
  width: 100%;
}

html{

}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
body{
  margin: 0px;
  padding: 0px;
	box-sizing: border-box;
}
p{
  margin: 0px;
	box-sizing: border-box;
}
div{
	box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/App.vue